import React from 'react';
import { useSelector } from 'react-redux';
import Bar from '../../../../components/elements/Bar';
import List from '../../../../components/elements/List';
import { Pencil } from 'lucide-react';

const detailData = ({ identifier, title, name_official, is_active, is_archived }: any = {}) => {
  return [
    { name: 'Číslo akce', value: identifier },
    { name: 'Interní název', value: title },
    { name: 'Oficiální název', value: name_official },
    { name: 'Aktivní', value: is_active ? 'Ano' : 'Ne' },
    { name: 'Archivovaná', value: is_archived ? 'Ano' : 'Ne' },
  ];
};

export default function ProjectDetailView({ data, makeEditable }) {
  const permission = useSelector((state) => state.auth.pagePermission);

  if (!data) {
    return null;
  }

  return (
    <div className="w-full">
      <Bar
        text={'Detail akce'}
        content={
          permission === 2 && data
            ? [
                <Pencil
                  key={1}
                  className="h-4 w-4"
                  data-testid="project-detail-edit-btn"
                  onClick={makeEditable}
                />,
              ]
            : []
        }
      />
      <List data={detailData(data || {})} />
      <Bar text={'Životní etapa stavby'} content={[]} />
      {data && (
        <List
          data={[
            {
              name: 'Životní etapa',
              value: data?.etape?.title,
            },
          ]}
        />
      )}
      <Bar text={'Další parametry'} content={[]} />
      {data && (
        <List
          data={[
            {
              name: 'Jazyková kultura projektu',
              value: data?.culture?.title,
            },
          ]}
        />
      )}
    </div>
  );
}
